var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about mt-10",attrs:{"align":"center"}},[_c('h1',[_vm._v("Navegaste a una pagina que no existe!!!")])])
}]

export { render, staticRenderFns }